import React from 'react'
import { reduxForm, Field, InjectedFormProps } from 'redux-form'
import { useTranslation } from 'react-i18next'

import OnboardingLayout from 'components/Onboarding/Layout'
import Button from 'components/Shared/Button'
import WrappedInput from 'components/Shared/Forms/WrappedInput'
import AdaloLogotype from 'components/Onboarding/AdaloLogotype'
import { FormRow } from './utils'

const FORM_NAME = 'twoFactorAuthLoginForm'

type Props = {
  submitting?: boolean
  error?: string
  handleSubmit: () => void
}

type TwoFactorAuthLoginFormValues = {
  authCode: string
}

type TwoFactorAuthLoginFormFC = React.FC<
  Props & InjectedFormProps<TwoFactorAuthLoginFormValues, Props>
>

const TwoFactorAuthLoginForm: TwoFactorAuthLoginFormFC = props => {
  const { handleSubmit, error, submitting } = props
  const { t } = useTranslation()

  return (
    <OnboardingLayout>
      <form onSubmit={handleSubmit} className="auth-form-v2">
        <div className="auth-form-v2__header">
          <AdaloLogotype />
          <h1>{t('Two-Factor Authentication')}</h1>
        </div>
        <div className="auth-form-v2__content">
          <FormRow>
            <Field
              autoFocus
              name="authCode"
              placeholder={t('Enter authentication code')}
              type="text"
              label={t('Authentication Code')}
              autoComplete="one-time-code"
              component={WrappedInput}
            />
          </FormRow>
          <div className="auth-form-submission-row">
            <Button square gradient large teal fluid loading={submitting}>
              {t('Verify')}
            </Button>
          </div>
          {error && <div className="auth-form-error">{error}</div>}
        </div>
      </form>
    </OnboardingLayout>
  )
}

export default reduxForm<TwoFactorAuthLoginFormValues, Props>({
  form: FORM_NAME,
})(TwoFactorAuthLoginForm)
